import castArray from "lodash/castArray";
import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";

import shouldBeDisplayed from "./shouldBeDisplayed";

export default function getEmailPlaceholderImages(
  emailImages,
  userChoiceValues
) {
  return flow(
    castArray,
    filter((placeholder) => placeholder?.url),
    filter(shouldBeDisplayed(userChoiceValues)),
    map((placeholder) => {
      const url = placeholder?.url?.split("?fmt=")[0];
      return {
        imageSet: placeholder?.imageSet,
        images: url ? [url, url] : [],
      };
    })
  )(emailImages);
}
